import { render, staticRenderFns } from "./SchoolOpen.vue?vue&type=template&id=a2d45df6&"
import script from "./SchoolOpen.vue?vue&type=script&lang=js&"
export * from "./SchoolOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports